import React from "react";
import { object } from "prop-types";
import { StoryElement } from "@quintype/components";

import "../story-templates/blank.m.css";

export const HeroImageElement = ({ story }) => {
  const element = {
    "image-metadata": story["hero-image-metadata"],
    type: "image",
    "image-attribution": story["hero-image-attribution"],
    title: story["hero-image-caption"],
    id: story.id,
    "alt-text": story["hero-image-alt-text"],
    hyperlink: story["hero-image-hyperlink"],
    "image-s3-key": story["hero-image-s3-key"],
    metadata: story.metadata,
    subtype: null,
  };

  return <StoryElement element={element} story={story} loadIframeOnClick />;
};

HeroImageElement.propTypes = {
  story: object,
};
